import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { useState } from "react";
import CreateCustomer from "../../components/Order/CreateCustomerForm";
import Modal from "../../components/Reusable/Modal";

const CreateMerchantComponent = loadable(
  () => import("../../components/Merchant/CreateMerchant")
);
const CreateMerchant = () => {
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false)
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false)
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["merchants"],
    navigateURL: "/merchant",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.MERCHANT}`;
    console.log(values)
    let formData = {
      ...values,
      "service_type": values?.service_type ? values?.service_type?.map((item: any, index: number) => (item?.value)) : [],
      "product_type": values?.product_type ? values?.product_type?.map((item: any, index: number) => (item?.value)) : [],
      "service_city": values?.service_city ? values?.service_city?.map((item: any, index: number) => (item?.value)) : [],
      "service_branch": values?.service_branch ? values?.service_branch?.map((item: any, index: number) => (item?.value)) : [],
      "mobile_number": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const { mutateAsync: createCustomerMutateAsync, isPostLoading: createCustomerLoading } = usePostHook({
    queryKey: ["customers"],
    navigateURL: null,
  });

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      const res = await createCustomerMutateAsync({ url, formData, setError });
      if (res.status === 201) {
        setOpenAddReceiverPopup(false)
        setOpenAddSenderPopup(false)
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Merchant</span>
      </div>
      <CreateMerchantComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        openAddReceiverPopup={openAddReceiverPopup}
        setOpenAddReceiverPopup={setOpenAddReceiverPopup}
        openAddSenderPopup={openAddSenderPopup}
        setOpenAddSenderPopup={setOpenAddSenderPopup}
      />
      <Modal
        isOpen={openAddReceiverPopup}
        setIsOpen={setOpenAddReceiverPopup}
        title={"Craeate Receiver"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
      <Modal
        isOpen={openAddSenderPopup}
        setIsOpen={setOpenAddSenderPopup}
        title={"Create Sender"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
    </>
  );
};

export default CreateMerchant;
